export const VideoPlaceholder: React.FC<
  /* { node: unknown } &*/ React.HtmlHTMLAttributes<HTMLVideoElement>
> = ({ /*node: _node,*/ children, ...restProps }) => (
  <video
    {...restProps}
    controls={false}
    preload="metadata"
    width="100%"
    style={{ cursor: 'pointer', objectFit: 'cover', aspectRatio: '16 / 9' }}
    autoPlay
    playsInline
    disableRemotePlayback
    disablePictureInPicture
    muted
  >
    {children}
  </video>
);
